import type { ISearchItem } from '@/assets/types/api/Search';

export const useSearchMenuStore = defineStore('searchMenuStore', () => {
  const nuxtApp = useNuxtApp();

  /* State */

  const searchValue = ref<string>('');
  const searchResults = ref<ISearchItem[]>([]);
  const isMenuOpen = ref<boolean>(false);

  /* Actions */

  const USE_GET_SEARCH = async () => {
    /**
     * 全站搜尋（Client Only）
     * 取前 16 筆，由元件依 type 分區
     */
    const { $i18n, $notification } = nuxtApp;
    const { locale } = $i18n;

    const query = computed(() => ({
      keyword: searchValue.value.trim(),
      websiteCode: locale.value,
      pageSize: 16,
    }));

    return await useCustomFetch(() => '/marketplace/api/v1/search', {
      method: 'GET',
      server: false,
      watch: false,
      query,
      lazy: true,
      immediate: false,
      onResponse: ({ response }) => {
        const { _data, status } = response;
        const data = _data as { items: ISearchItem[] };

        if (status >= 200 && status < 300) {
          searchResults.value = [...data.items];
        } else {
          console.error(_data);
          $notification({
            message: (_data as { message: string }).message,
            type: 'error',
          });
        }
      },
    });
  };

  const HANDLE_CLOSE_MENU = (): void => {
    /**
     * 關閉 MENU 視窗
     */
    isMenuOpen.value = false;
    searchValue.value = '';
    searchResults.value = [];
  };

  return {
    searchValue,
    searchResults,
    isMenuOpen,
    USE_GET_SEARCH,
    HANDLE_CLOSE_MENU,
  };
});
